import type { FC, ReactElement } from 'react';

import type { Trophy } from '../../../store/slices/promotionsV2/types';
import { Tooltip } from '../../tooltip/Tooltip';

import style from './TrophyIcon.module.css';

interface TrophyIconProps {
  trophy: Partial<Trophy>;
}

export const TrophyIcon: FC<TrophyIconProps> = ({ trophy }): ReactElement | null => {
  const { enable, isActive, minBet, toolTipContent } = trophy;

  if (!enable) return null;
  if (isActive) return <span className={style.trophyActive} />;
  if (!toolTipContent) return <span className={style.trophyInactive} />;
  return (
    <Tooltip
      attrs={minBet ? [minBet] : []}
      displayOnTouch
      displayTimer={5000}
      displayTrigger={!isActive}
      text={toolTipContent}
    >
      <span className={style.trophyInactive} />
    </Tooltip>
  );
};
